import logo from 'assets/images/yayfi-mark.svg';

// ==============================|| LOGO ICON ||============================== //

export default function LogoIcon() {
  return <img src={logo} alt="YaYfi" width={44} height={44} />;
}
